/**
 * Sentence shown under the headshot in the PDP "Need Assistance?" card.
 *
 * Firebase /locations records may carry an optional `Title` (e.g. a territory
 * rep record: "BCS representative"). When present the line reads
 * "Call {Manager}, your {Title}." Otherwise the legacy wording is kept
 * byte-for-byte so existing branches render exactly as before.
 *
 * Kept free of path aliases so it can be unit-tested with plain node.
 *
 * @param {{manager?: string, name?: string, title?: string}} branchLocation
 * @returns {string}
 */
export function branchContactLine(branchLocation) {
  const title = (branchLocation.title ?? '').trim();
  if (title) {
    return 'Call ' + branchLocation.manager + ', your ' + title + '.';
  }
  return 'Call ' + branchLocation.manager + ', your local ' + branchLocation.name + ' branch manager';
}
